<section class="content-section">
  <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 32px; border-bottom: 2px solid rgba(0,0,0,0.06); padding-bottom: 0;">
    <button 
      type="button"
      class="btn"
      [class.btn-primary]="activeTab === 'general'"
      [class.btn-secondary]="activeTab !== 'general'"
      (click)="switchTab('general')"
      style="border-radius: 10px 10px 0 0; margin-bottom: -2px; padding: 12px 20px; border-bottom: 3px solid transparent;"
      [style.border-bottom-color]="activeTab === 'general' ? 'var(--primary-color)' : 'transparent'">
      🌐 Général
    </button>
    @if (estAdministrateur) {
    <button 
      type="button"
      class="btn"
      [class.btn-primary]="activeTab === 'notifications'"
      [class.btn-secondary]="activeTab !== 'notifications'"
      (click)="switchTab('notifications')"
      style="border-radius: 10px 10px 0 0; margin-bottom: -2px; padding: 12px 20px; border-bottom: 3px solid transparent;"
      [style.border-bottom-color]="activeTab === 'notifications' ? 'var(--primary-color)' : 'transparent'">
      🔔 Notifications
    </button>
    <button
      type="button"
      class="btn"
      [class.btn-primary]="activeTab === 'entreprise'"
      [class.btn-secondary]="activeTab !== 'entreprise'"
      (click)="switchTab('entreprise')"
      style="border-radius: 10px 10px 0 0; margin-bottom: -2px; padding: 12px 20px; border-bottom: 3px solid transparent;"
      [style.border-bottom-color]="activeTab === 'entreprise' ? 'var(--primary-color)' : 'transparent'">
      🏢 Entreprise
    </button>
    <button
      type="button"
      class="btn"
      [class.btn-primary]="activeTab === 'couts'"
      [class.btn-secondary]="activeTab !== 'couts'"
      (click)="switchTab('couts')"
      style="border-radius: 10px 10px 0 0; margin-bottom: -2px; padding: 12px 20px; border-bottom: 3px solid transparent;"
      [style.border-bottom-color]="activeTab === 'couts' ? 'var(--primary-color)' : 'transparent'">
      💰 Coûts opérationnels
    </button>
    }
  </div>

  @if (activeTab === 'general') {
    <form class="form-container" (ngSubmit)="onSubmit()">
      <div class="form-section">
        <h3 class="form-section-title">Paramètres Généraux</h3>
        <div class="form-group">
          <label class="form-label">Format de date</label>
          <select class="form-select">
            <option value="dd/MM/yyyy">JJ/MM/AAAA</option>
            <option value="MM/dd/yyyy">MM/JJ/AAAA</option>
            <option value="yyyy-MM-dd">AAAA-MM-JJ</option>
          </select>
          <p class="form-help">Choisissez le format d'affichage des dates</p>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary">Enregistrer les modifications</button>
      </div>
    </form>
  }

  @if (estAdministrateur && activeTab === 'notifications') {
    <form class="form-container" (ngSubmit)="onSubmit()">
      <div class="form-section">
        <h3 class="form-section-title">Préférences de notifications</h3>
        
        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" checked>
            <span><strong>Notifications Email</strong><br>
            <small style="color: var(--text-secondary);">Recevoir des notifications par email</small></span>
          </label>
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" checked>
            <span><strong>Notifications Push</strong><br>
            <small style="color: var(--text-secondary);">Recevoir des notifications navigateur</small></span>
          </label>
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" checked>
            <span><strong>Alertes nouvelles commandes</strong><br>
            <small style="color: var(--text-secondary);">Être notifié des nouvelles commandes</small></span>
          </label>
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" checked>
            <span><strong>Alertes changement de statut</strong><br>
            <small style="color: var(--text-secondary);">Être notifié des changements de statut</small></span>
          </label>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary">Enregistrer les modifications</button>
      </div>
    </form>
  }

  @if (estAdministrateur && activeTab === 'entreprise') {
    <form class="form-container" (ngSubmit)="onSubmit()">
      <div class="form-section">
        <h3 class="form-section-title">Informations de l'entreprise</h3>
        
        <div class="form-group">
          <label class="form-label">Nom de l'entreprise *</label>
          <input type="text" class="form-input" value="Dematral Express" placeholder="Nom entreprise">
        </div>

        <div class="form-group">
          <label class="form-label">Email de contact *</label>
          <input type="email" class="form-input" value="contact@dematralexpress.com" placeholder="Email">
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Téléphone *</label>
            <input type="text" class="form-input" value="+225 07 07 07 07 07" placeholder="Téléphone">
          </div>
          <div class="form-group">
            <label class="form-label">Site web</label>
            <input type="text" class="form-input" placeholder="https://exemple.com">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Adresse complète *</label>
          <textarea class="form-input" rows="3" placeholder="Adresse">Abidjan, Côte d'Ivoire</textarea>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Ville</label>
            <input type="text" class="form-input" value="Abidjan">
          </div>
          <div class="form-group">
            <label class="form-label">Pays</label>
            <select class="form-select">
              <option value="CI" selected>Côte d'Ivoire</option>
              <option value="SN">Sénégal</option>
              <option value="BF">Burkina Faso</option>
              <option value="ML">Mali</option>
            </select>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary">Enregistrer les modifications</button>
      </div>
    </form>
  }
  @if (estAdministrateur && activeTab === 'couts') {
    <div class="cout-page">

      <!-- En-tête -->
      <div class="cout-header">
        <div class="cout-header__icon">💰</div>
        <div>
          <h2 class="cout-header__title">Coûts opérationnels</h2>
          <p class="cout-header__subtitle">Saisissez vos charges mensuelles par zone pour alimenter les indicateurs de marge brute et coût par colis dans les Rapports.</p>
        </div>
      </div>

      <div class="cout-layout">

        <!-- ── Formulaire ── -->
        <div class="cout-form-card">
          <div class="cout-form-card__header">
            <span class="cout-form-card__header-icon">✏️</span>
            <span>{{ formulaireCout.id ? 'Modifier l\'entrée' : 'Nouvelle saisie' }}</span>
          </div>

          <!-- Période -->
          <div class="cout-fieldset">
            <div class="cout-fieldset__legend">Période &amp; Zone</div>
            <div class="cout-grid-3">
              <div class="cout-field">
                <label class="cout-label">Zone</label>
                <select class="cout-select" [(ngModel)]="formulaireCout.zoneId">
                  <option [value]="null">Toutes zones</option>
                  @for (z of zones; track z.id) {
                    <option [value]="z.id">{{ z.nom }}</option>
                  }
                </select>
              </div>
              <div class="cout-field">
                <label class="cout-label">Mois</label>
                <select class="cout-select" [(ngModel)]="formulaireCout.mois">
                  @for (m of moisOptions; track m.val) {
                    <option [value]="m.val">{{ m.label }}</option>
                  }
                </select>
              </div>
              <div class="cout-field">
                <label class="cout-label">Année</label>
                <select class="cout-select" [(ngModel)]="formulaireCout.annee">
                  @for (a of anneeOptions; track a) {
                    <option [value]="a">{{ a }}</option>
                  }
                </select>
              </div>
            </div>
          </div>

          <!-- Charges -->
          <div class="cout-fieldset">
            <div class="cout-fieldset__legend">Charges mensuelles (FCFA)</div>
            <div class="cout-grid-2">
              <div class="cout-field">
                <label class="cout-label">
                  <span class="cout-label__dot cout-label__dot--fuel"></span>Carburant
                </label>
                <div class="cout-input-wrap">
                  <input type="number" class="cout-input" min="0" [(ngModel)]="formulaireCout.coutCarburant" placeholder="0">
                  <span class="cout-input__unit">FCFA</span>
                </div>
              </div>
              <div class="cout-field">
                <label class="cout-label">
                  <span class="cout-label__dot cout-label__dot--work"></span>Main d'œuvre
                </label>
                <div class="cout-input-wrap">
                  <input type="number" class="cout-input" min="0" [(ngModel)]="formulaireCout.coutMainOeuvre" placeholder="0">
                  <span class="cout-input__unit">FCFA</span>
                </div>
              </div>
              <div class="cout-field">
                <label class="cout-label">
                  <span class="cout-label__dot cout-label__dot--maint"></span>Entretien véhicules
                </label>
                <div class="cout-input-wrap">
                  <input type="number" class="cout-input" min="0" [(ngModel)]="formulaireCout.coutEntretien" placeholder="0">
                  <span class="cout-input__unit">FCFA</span>
                </div>
              </div>
              <div class="cout-field">
                <label class="cout-label">
                  <span class="cout-label__dot cout-label__dot--hub"></span>Centre de tri
                </label>
                <div class="cout-input-wrap">
                  <input type="number" class="cout-input" min="0" [(ngModel)]="formulaireCout.coutCentreTri" placeholder="0">
                  <span class="cout-input__unit">FCFA</span>
                </div>
              </div>
              <div class="cout-field">
                <label class="cout-label">
                  <span class="cout-label__dot cout-label__dot--other"></span>Autres charges
                </label>
                <div class="cout-input-wrap">
                  <input type="number" class="cout-input" min="0" [(ngModel)]="formulaireCout.autresCharges" placeholder="0">
                  <span class="cout-input__unit">FCFA</span>
                </div>
              </div>
              <div class="cout-field">
                <label class="cout-label">Nb colis traités <span style="font-weight:400;opacity:.65">(optionnel)</span></label>
                <div class="cout-input-wrap">
                  <input type="number" class="cout-input" min="0" [(ngModel)]="formulaireCout.nombreColisTraites" placeholder="Auto-calculé">
                  <span class="cout-input__unit">colis</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Total dynamique -->
          <div class="cout-summary">
            <div class="cout-summary__bars">
              <div class="cout-summary__bar cout-summary__bar--fuel"
                   [style.flex]="(formulaireCout.coutCarburant||0)" title="Carburant"></div>
              <div class="cout-summary__bar cout-summary__bar--work"
                   [style.flex]="(formulaireCout.coutMainOeuvre||0)" title="Main d'œuvre"></div>
              <div class="cout-summary__bar cout-summary__bar--maint"
                   [style.flex]="(formulaireCout.coutEntretien||0)" title="Entretien"></div>
              <div class="cout-summary__bar cout-summary__bar--hub"
                   [style.flex]="(formulaireCout.coutCentreTri||0)" title="Centre tri"></div>
              <div class="cout-summary__bar cout-summary__bar--other"
                   [style.flex]="(formulaireCout.autresCharges||0)" title="Autres"></div>
            </div>
            <div class="cout-summary__line">
              <span class="cout-summary__label">Total mensuel</span>
              <span class="cout-summary__value">
                {{ (formulaireCout.coutCarburant||0)+(formulaireCout.coutMainOeuvre||0)+(formulaireCout.coutEntretien||0)+(formulaireCout.coutCentreTri||0)+(formulaireCout.autresCharges||0) | number:'1.0-0' }}
                <small>FCFA</small>
              </span>
            </div>
          </div>

          <div class="cout-actions">
            <button class="cout-btn cout-btn--primary" (click)="sauvegarderCout()" [disabled]="sauvegardeEnCours">
              <span>{{ sauvegardeEnCours ? '⏳ Enregistrement...' : '✓ Enregistrer' }}</span>
            </button>
            <button class="cout-btn cout-btn--ghost" (click)="reinitialiserFormulaire()">Réinitialiser</button>
          </div>
        </div>

        <!-- ── Tableau ── -->
        <div class="cout-table-card">
          <div class="cout-table-card__header">
            <div>
              <span class="cout-form-card__header-icon">📋</span>
              <span>Coûts enregistrés</span>
            </div>
            <button class="cout-btn cout-btn--ghost cout-btn--sm" (click)="chargerCouts()">↻ Actualiser</button>
          </div>

          @if (chargementCouts) {
            <div class="cout-loading">
              <div class="cout-loading__spinner"></div>
              <p>Chargement...</p>
            </div>
          } @else if (couts.length === 0) {
            <div class="cout-empty">
              <div class="cout-empty__icon">📊</div>
              <p class="cout-empty__title">Aucun coût enregistré</p>
              <p class="cout-empty__hint">Utilisez le formulaire ci-contre pour saisir vos charges mensuelles par zone.</p>
            </div>
          } @else {
            <div class="cout-cards-list">
              @for (c of couts; track c.id) {
                <div class="cout-entry-card">
                  <div class="cout-entry-card__top">
                    <div class="cout-entry-card__meta">
                      <span class="cout-zone-badge">{{ nomZone(c.zone?.id) }}</span>
                      <span class="cout-period-badge">{{ nomMois(c.mois) }} {{ c.annee }}</span>
                    </div>
                    <div class="cout-entry-card__actions">
                      <button class="cout-icon-btn cout-icon-btn--edit" title="Modifier" (click)="editerCout(c)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </button>
                      <button class="cout-icon-btn cout-icon-btn--delete" title="Supprimer" (click)="supprimerCout(c.id)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                      </button>
                    </div>
                  </div>
                  <div class="cout-entry-card__bars">
                    <div class="cout-entry-bar" *ngIf="c.coutCarburant > 0">
                      <span class="cout-entry-bar__dot cout-label__dot--fuel"></span>
                      <span class="cout-entry-bar__label">Carburant</span>
                      <span class="cout-entry-bar__val">{{ c.coutCarburant | number:'1.0-0' }}</span>
                    </div>
                    <div class="cout-entry-bar" *ngIf="c.coutMainOeuvre > 0">
                      <span class="cout-entry-bar__dot cout-label__dot--work"></span>
                      <span class="cout-entry-bar__label">Main d'œuvre</span>
                      <span class="cout-entry-bar__val">{{ c.coutMainOeuvre | number:'1.0-0' }}</span>
                    </div>
                    <div class="cout-entry-bar" *ngIf="c.coutEntretien > 0">
                      <span class="cout-entry-bar__dot cout-label__dot--maint"></span>
                      <span class="cout-entry-bar__label">Entretien</span>
                      <span class="cout-entry-bar__val">{{ c.coutEntretien | number:'1.0-0' }}</span>
                    </div>
                    <div class="cout-entry-bar" *ngIf="c.coutCentreTri > 0">
                      <span class="cout-entry-bar__dot cout-label__dot--hub"></span>
                      <span class="cout-entry-bar__label">Centre de tri</span>
                      <span class="cout-entry-bar__val">{{ c.coutCentreTri | number:'1.0-0' }}</span>
                    </div>
                    <div class="cout-entry-bar" *ngIf="c.autresCharges > 0">
                      <span class="cout-entry-bar__dot cout-label__dot--other"></span>
                      <span class="cout-entry-bar__label">Autres</span>
                      <span class="cout-entry-bar__val">{{ c.autresCharges | number:'1.0-0' }}</span>
                    </div>
                  </div>
                  <div class="cout-entry-card__footer">
                    <span>Total</span>
                    <strong>{{ total(c) | number:'1.0-0' }} FCFA</strong>
                  </div>
                </div>
              }
            </div>
          }
        </div>

      </div>
    </div>
  }
</section>
